export enum ERoutes {
  ABOUT = 'om',
  APPS = 'apps',
  APPS_IOS = 'ios',
  APPS_ANDROID = 'android',
  APPS_WINDOWS = 'windows',
  APPS_MACOS = 'macos',
  APPS_LINUX = 'linux',
  APPS_WEB = 'web',
  APPS_CLI = 'cli',
  ARTICLES = 'articles',
  COOKIE_POLICY = 'cookies',
  DATA = 'data',
  HELP = 'hjelp',
  MAP = 'bredbandskart',
  METHODOLOGY = 'metodikk',
  MUNICIPALITY = 'internettstatistikk/:name',
  OPEN_DATA = 'apne-data',
  PRIVACY_POLICY = 'personvernerklaering',
  SOLUTIONS = 'solutions',
  SOLUTIONS_OVERVIEW = 'overview',
  SOLUTIONS_CROWD = 'crowdsourcing-applications',
  SOLUTIONS_WEB = 'web-portal',
  SOLUTIONS_REGULATORY = 'regulatory-portal',
  SOLUTIONS_DASHBOARDS = 'dashboards',
  SOLUTIONS_AUTO = 'automated-measurements',
  STATISTICS = 'internettstatistikk',
  TERMS_OF_SERVICE = 'brukervilkar',
  TEST = 'test',
  TEST_PROGRESS = 'progress',
  TEST_HISTORY = 'historikk',
  TEST_HYSTORY_RESULTS = 'resultater/:id',
  PAGE_NOT_FOUND = 'page-not-found',
  WIZARD = 'wizard',
  CONTACT = 'contact',
}
